'use strict';

import 'document-register-element';
import SplitText from 'SplitText';

import resizeStore from '../resize/resize.store';
import scrollStore from './scroll.store';
import loaderStore from '../navigation/loader.store';



class Scrl extends HTMLElement{
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this.active = false;

    this.vw = 0;
    this.vh = 0;
    this.top = 0;
    this.height = 0;
    this.bottom = 0;
    this.stick = 0;

    this.activate = () => this._activate();
    this.subscribe = (e) => this._subscribe(e);
    this.handleResize = (e) => this._onResize(e);
    this.handleScroll = (e) => this._onScroll(e);
  }
  connectedCallback() {
    if (this.dataset.custom) {
      const custom = this.querySelector(this.dataset.custom);

      if (custom) {
        this.activate = () => {
          custom.play();
          this._activate();
        }
      }
    // } else if (this.dataset.text) {
    } else {
      const titles = this.querySelectorAll('h1, h2, h3, .h1, .h2, .h3');
      this.words = [];
      Array.from(titles).forEach(title => {
        const split = new SplitText(title, {type: 'words', wordsClass: 'split-word'});
        this.words = [...this.words, ...split.words];
      });

      TweenLite.set(this.words, {
        y: 20,
        opacity: 0
      });

      this.activate = () => {
        this._activate();

        TweenMax.staggerTo(this.words, 0.8, {
          delay: 0.2,
          y: 0,
          opacity: 1
        }, 0.05);
      }
    }

    loaderStore.eventEmitter.subscribe(this.subscribe);
    resizeStore.eventEmitter.subscribe(this.handleResize);
    scrollStore.eventEmitter.subscribe(this.handleScroll);
  }
  disconnectedCallback() {
    loaderStore.eventEmitter.unsubscribe(this.subscribe);
    resizeStore.eventEmitter.unsubscribe(this.handleResize);
    scrollStore.eventEmitter.unsubscribe(this.handleScroll);
  }
  _subscribe(e) {
    if (e.type === 'load-animation-play' && e.loadAnimation === 'end-complete') this._onResize(resizeStore.getData());
  }
  _activate() {
    this.classList.add('show');

    this.active = true;
  }

  _onResize(e) {
    if (this.active) return;

    let scrollData = scrollStore.getData();
    this.vw = e.width;
    this.vh = e.height;


    this.top = this.getBoundingClientRect().top + scrollData.top;
    this.height = this.offsetHeight;
    this.bottom = this.top + this.height;
    this.stick = this.height * 0.5 > 150 ? 150 : this.height * 0.5;

    this._onScroll(scrollData);
  }
  _onScroll(e) {
    if (this.active) return;

    let top = e.top;

    if (this.top + this.stick < top + this.vh && this.bottom - this.stick > top) {
      this.activate();
    }
  }
}

window.customElements.define('scrl-view', Scrl);
